export const MAX_NUMBER_OF_HOTELS = 30;
